/**
 * Pages that moved into the Updates area on 2026-10-26, old prefix first. The old addresses stay
 * valid: bookmarks, links in audit rows and older notifications keep landing on the right page.
 * Longer prefixes first, so a sub-path is never matched by a shorter sibling.
 */
export const MOVED_TO_UPDATES: ReadonlyArray<readonly [string, string]> = [
  ['/releases', '/updates/releases'],
  ['/firmware', '/updates/builds'],
  ['/cohorts', '/updates/groups'],
  ['/webhooks', '/updates/settings/notifications'],
  ['/rings', '/updates/settings'],
]

/** The new address for an old one, with the rest of the path kept; null when it did not move. */
export function movedPath(pathname: string): string | null {
  if (pathname === '/fleet') return '/updates/overview'
  for (const [from, to] of MOVED_TO_UPDATES) {
    if (pathname === from || pathname.startsWith(`${from}/`)) return to + pathname.slice(from.length)
  }
  return null
}
